/**
 * Motion design tokens.
 *
 * Centralised durations / easings / distances so every Reveal & Stagger looks
 * the same and we can tune the whole system from one place.
 */

export const motionDuration = {
  fast: 0.25,
  base: 0.6,
  slow: 0.9,
} as const

export const motionEase = {
  /** Standard "ease-out" cubic; good default for entrances. */
  out: [0.0, 0.0, 0.2, 1.0] as const,
  /** Symmetric ease for hover/state transitions. */
  inOut: [0.45, 0, 0.55, 1] as const,
} as const

export const motionDistance = {
  sm: 8,
  md: 20,
  lg: 40,
} as const

/** Default stagger between children inside a `<Stagger>` block. */
export const staggerStep = 0.1

/** Default `viewport` config for whileInView animations. */
export const inViewOnce = {
  once: true,
  margin: '-200px 0px',
} as const
